import axios from "axios";

const baseURL = "https://patientapp.edigitizeyourself.com/v1";
// const baseURL = "http://192.168.1.3:5000/v1";


const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    localStorage.removeItem("access_token");
    return Promise.reject(error);
  }
);

export default axiosInstance;
